import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/', // 首页
      name: 'index',
      component: resolve => require(['@/views/index/index'], resolve),
    },
    {
      path: '/hardwareList', // 硬件列表
      name: 'hardwareList',
      component: resolve => require(['@/views/hardware/hardwareList'], resolve),
      children:[

      ]
    },
    {
      path: '/hardwareDetails', // 硬件详情
      name: 'hardwareDetails',
      component: resolve => require(['@/views/hardware/hardwareDetails'], resolve),
    },
    {
      path: '/softwareList', // 软件列表
      name: 'softwareList',
      component: resolve => require(['@/views/software/softwareList'], resolve),
    },
    {
      path: '/joinUs', // 加入我们
      name: 'joinUs',
      component: resolve => require(['@/views/JoinUs/index'], resolve),
    },
    {
      path: '/positionList', // 职位列表及详情
      name: 'positionList',
      component: resolve => require(['@/views/JoinUs/positionList'], resolve),
    },
    {
      path: '/intelligentIndustry', // 智能工业
      name: 'intelligentIndustry',
      component: resolve => require(['@/views/caseDetails/intelligentIndustry'], resolve),
    },
    {
      path: '/bby_iot_platform', // 百倍云物联网平台    
      name: 'bby_iot_platform',
      component: resolve => require(['@/views/caseDetails/bby_iot_platform'], resolve),
    },
    {
      path: '/campany', // 代理合作    
      name: 'campany',
      component: resolve => require(['@/views/campany/index'], resolve),
    },
    {
      path: '/zhanting', // 展厅    
      name: 'zhanting',
      component: resolve => require(['@/views/caseDetails/zhanting'], resolve),
    },
    {
      path: '/aboutUs', // 关于我们    
      name: 'aboutUs',
      component: resolve => require(['@/views/about/index'], resolve),
    },
    {
      path: '/jijiagong', // 机加工互联    
      name: 'jijiagong',
      component: resolve => require(['@/views/caseDetails/jijiagong'], resolve),
    },
    {
      path: '/farming', // 智慧农业-赣州农业   
      name: 'farming',
      component: resolve => require(['@/views/industrialApp/farming'], resolve),
    },
    {
      path: '/mingyue', // 明月眼镜
      name: 'mingyue',
      component: resolve => require(['@/views/caseDetails/mingyue'], resolve),
    },
    {
      path: '/huanjing', // 环保大数据
      name: 'huanjing',
      component: resolve => require(['@/views/caseDetails/huanjing'], resolve),
    },
    {
      path: '/dahezi', // 大盒子洗车
      name: 'dahezi',
      component: resolve => require(['@/views/industrialApp/dahezi'], resolve),
    },
    {
      path: '/industrial_internet', // 百倍云工业互联网
      name: 'industrial_internet',
      component: resolve => require(['@/views/caseDetails/industrial_internet'], resolve),
    },
    {
      path: '/industrial_interconnection', // 工业互联1
      name: 'industrial_interconnection',
      component: resolve => require(['@/views/caseDetails/industrial_interconnection'], resolve),
    },
    {
      path: '/industrial_interconnection2', // 工业互联2
      name: 'industrial_interconnection2',
      component: resolve => require(['@/views/caseDetails/industrial_interconnection2'], resolve),
    },
    {
      path: '/intelligentWorkOrder', // 智能工单
      name: 'intelligentWorkOrder',
      component: resolve => require(['@/views/caseDetails/intelligentWorkOrder'], resolve),
    },
    {
      path: '/gongye_oa', // 工业OA
      name: 'gongye_oa',
      component: resolve => require(['@/views/caseDetails/gongye_oa'], resolve),
    },
    {
      path: '/newslist', // 新闻列表
      name: 'newslist',
      component: resolve => require(['@/views/caseDetails/newslist'], resolve),
    },
    {
      path: '/newsdetail', // 新闻详情
      name: 'newsdetail',
      component: resolve => require(['@/views/caseDetails/newsdetail'], resolve),
    },
    {
      path: '/intelligentWorkOrderERP', // 智能工单ERP
      name: 'intelligentWorkOrderERP',
      component: resolve => require(['@/views/caseDetails/intelligentWorkOrderERP'], resolve),
    },
    {
      path: '/lithiumBatteryMES', // 锂电池MES
      name: 'lithiumBatteryMES',
      component: resolve => require(['@/views/caseDetails/lithiumBatteryMES'], resolve),
    },
    {
      path: '/factoryFireControl', // 厂区消防
      name: 'factoryFireControl',
      component: resolve => require(['@/views/caseDetails/factoryFireControl'], resolve),
    },
    {
      path: '/viewChemicalIndustry', // 视觉化工智慧平台
      name: 'viewChemicalIndustry',
      component: resolve => require(['@/views/caseDetails/viewChemicalIndustry'], resolve),
    },
    {
      path: '/intelligentIndustry2', // 智能工业2
      name: 'intelligentIndustry2',
      component: resolve => require(['@/views/caseDetails/intelligentIndustry2'], resolve),
    },
    {
      path: '/intelligentMotor', // 智能电机
      name: 'intelligentMotor',
      component: resolve => require(['@/views/caseDetails/intelligentMotor'], resolve),
    },
    {
      path: '/chintMeter', // 正泰电表
      name: 'chintMeter',
      component: resolve => require(['@/views/industrialApp/chintMeter'], resolve),
    },
    {
      path: '/apartmentMeter', // 公寓电表
      name: 'apartmentMeter',
      component: resolve => require(['@/views/industrialApp/apartmentMeter'], resolve),
    },
    {
      path: '/networkIntelligence', // 光网络智能化巡检
      name: 'networkIntelligence',
      component: resolve => require(['@/views/caseDetails/networkIntelligence'], resolve),
    },
    {
      path: '/newEnergyCar', // 新能源汽车
      name: 'newEnergyCar',
      component: resolve => require(['@/views/caseDetails/newEnergyCar'], resolve),
    },
    {
      path: '/smartCampus', // 智慧校园
      name: 'smartCampus',
      component: resolve => require(['@/views/caseDetails/smartCampus'], resolve),
    },
    {
      path: '/microseismic', // 微震
      name: 'microseismic',
      component: resolve => require(['@/views/caseDetails/microseismic'], resolve),
    },
    {
      path: '/refuseClass', // 智能垃圾分类箱
      name: 'refuseClass',
      component: resolve => require(['@/views/caseDetails/refuseClass'], resolve),
    },
    {
      path: '/industrialIntelligenceUnion', // 数字乡村app
      name: 'industrialIntelligenceUnion',
      component: resolve => require(['@/views/industrialApp/industrialIntelligenceUnion'], resolve),
    },
    {
      path: '/EEEManagement', // 电能能效管理
      name: 'EEEManagement',
      component: resolve => require(['@/views/industrialApp/EEEManagement'], resolve),
    },
    {
      path: '/beautiful', // 美容仪器
      name: 'beautiful',
      component: resolve => require(['@/views/industrialApp/beautiful'], resolve),
    },
    {
      path: '/jijiagongApp', // 机加工app
      name: 'jijiagongApp',
      component: resolve => require(['@/views/industrialApp/jijiagongApp'], resolve),
    },
    {
      path: '/intelligentAgriculture', // 智慧农业 -- 解决方案
      name: 'intelligentAgriculture',
      component: resolve => require(['@/views/caseDetails/intelligentAgriculture'], resolve),
    },
    {
      path: '/pestMonitoring', // 智慧农业 -- 虫情监测
      name: 'pestMonitoring',
      component: resolve => require(['@/views/caseDetails/pestMonitoring'], resolve),
    },
    {
      path: '/high_standard_farmland', // 高标准农田建设方案
      name: 'high_standard_farmland',
      component: resolve => require(['@/views/caseDetails/high_standard_farmland'], resolve),
    },{
      path: '/water_level_detection', // 水位监测 
      name: 'water_level_detection',
      component: resolve => require(['@/views/caseDetails/water_level_detection'], resolve),
    },{
      path: '/Integration_of_water_and_fertilizer', // 水肥一体化 
      name: 'Integration_of_water_and_fertilizer',
      component: resolve => require(['@/views/caseDetails/Integration_of_water_and_fertilizer'], resolve),
    },{
      path: '/Plant_factory', // 未来工厂 
      name: 'Plant_factory',
      component: resolve => require(['@/views/caseDetails/Plant_factory'], resolve),
    },{
      path: '/Future_farm', // 植物工厂 
      name: 'Future_farm',
      component: resolve => require(['@/views/caseDetails/Future_farm'], resolve),
    },{
      path: '/wuzhen', // 乌镇 
      name: 'wuzhen',
      component: resolve => require(['@/views/caseDetails/wuzhen'], resolve),
    },{
      path: '/xiaojinxian', // 小金县 
      name: 'xiaojinxian',
      component: resolve => require(['@/views/caseDetails/xiaojinxian'], resolve),
    },{
      path: '/xincangcha', // 新昌茶 
      name: 'xincangcha',
      component: resolve => require(['@/views/caseDetails/xincangcha'], resolve),
    },{
      path: '/gaobiaozhun', // 高标准农田 
      name: 'gaobiaozhun',
      component: resolve => require(['@/views/caseDetails/gaobiaozhun'], resolve),
    },{
      path: '/wuranzhili', // 高标准农田 
      name: 'wuranzhili',
      component: resolve => require(['@/views/caseDetails/wuranzhili'], resolve),
    },{
      path: '/gongxiangtianyuan', // 高标准农田 
      name: 'gongxiangtianyuan',
      component: resolve => require(['@/views/caseDetails/gongxiangtianyuan'], resolve),
    },{
      path: '/xunyu', // 高标准农田 
      name: 'xunyu',
      component: resolve => require(['@/views/caseDetails/xunyu'], resolve),
    },{
      path: '/kzss', // 高标准农田 
      name: 'kzss',
      component: resolve => require(['@/views/caseDetails/kzss'], resolve),
    },
    
    
    
    {
      path: '/digitalFishery', // 智慧农业 -- 渔场
      name: 'digitalFishery',
      component: resolve => require(['@/views/caseDetails/digitalFishery'], resolve),
    },
    {
      path: '/zhihui2.5', // 智慧农业2.5D
      name: 'zhihui2.5',
      component: resolve => require(['@/views/caseDetails/zhihui2.5'], resolve),
    },
    {
      path: '/nongyesuyuan', //农业溯源
      name: 'nongyesuyuan',
      component: resolve => require(['@/views/caseDetails/nongyesuyuan'], resolve),
    },
    {
      path: '/online_retailers', //农业电商
      name: 'online_retailers',
      component: resolve => require(['@/views/caseDetails/online_retailers'], resolve),
    },
    
    {
      path: '/shuzixiangcun', //数字乡村
      name: 'shuzixiangcun',
      component: resolve => require(['@/views/caseDetails/shuzixiangcun'], resolve),
    }, {
      path: '/digitalpigraising', //数字养猪
      name: 'digitalpigraising',
      component: resolve => require(['@/views/caseDetails/digitalpigraising'], resolve),
    },{
      path: '/fishAndVeg', //鱼菜共生
      name: 'fishAndVeg',
      component: resolve => require(['@/views/caseDetails/fishAndVeg'], resolve),
    },{
      path: '/allShareAac', //共享农田
      name: 'allShareAac',
      component: resolve => require(['@/views/caseDetails/allShareAac'], resolve),
    },
    {
      path: '/newPeople', //新农人
      name: 'newPeople',
      component: resolve => require(['@/views/caseDetails/newPeople'], resolve),
    },
    
    
    
    {
      path: '/smartpensionsolutions', //智慧养老解决方案
      name: 'smartpensionsolutions',
      component: resolve => require(['@/views/caseDetails/smartpensionsolutions'], resolve),
    },{
      path: '/farmingandagriculturalmaterials', //农事农资解决方案
      name: 'farmingandagriculturalmaterials',
      component: resolve => require(['@/views/caseDetails/farmingandagriculturalmaterials'], resolve),
    },{
      path: '/village_resources', //乡村资源一张图
      name: 'village_resources',
      component: resolve => require(['@/views/caseDetails/village_resources'], resolve),
    },{
      path: '/greenhouse', //大棚农业
      name: 'greenhouse',
      component: resolve => require(['@/views/caseDetails/greenhouse'], resolve),
    },
    
    
    {
      path: '/intelligentAgricultureall', // 智慧农业综合版
      name: 'intelligentAgricultureall',
      component: resolve => require(['@/views/caseDetails/intelligentAgricultureall'], resolve),
    },
    {
      path: '/intelligentAgriculturexample', // 智慧农业案例
      name: 'intelligentAgriculturexample',
      component: resolve => require(['@/views/caseDetails/intelligentAgriculturexample'], resolve),
    },
    {
      path: '/smartSite', // 智慧工地
      name: 'smartSite',
      component: resolve => require(['@/views/caseDetails/smartSite'], resolve),
    },
    {
      path: '/smartToilet', // 智慧公厕
      name: 'smartToilet',
      component: resolve => require(['@/views/caseDetails/smartToilet'], resolve),
    },
    {
      path: '/contactUs', // 联系我们
      name: 'contactUs',
      component: resolve => require(['@/views/contactUs/index'], resolve),
    },
  ]
})
